import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SharedService } from '../../../../services/shared.service';
import { LocalStorage } from '../../../../services/local-storage';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../popupAdmin/popup-segment.component';
import { LoaderService } from '../../../../services/Spinner.service';

@Component({
    selector: 'app-header-admin',
    templateUrl: './header.component.html',
          providers: [SharedService, LocalStorage,PopupSegmentComponent]

    //styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    constructor(public router: Router,
    private shareService :SharedService,private localstorage : LocalStorage, private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService, private loaderService: LoaderService) {
        // this.router.events.subscribe((val) => {
        //     if (val instanceof NavigationEnd && window.innerWidth <= 992) {
        //         this.toggleSidebar();
        //     }
        // });


    }


    ngOnInit() {


    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle('pull-right');
    }

    onLoggedout() {
        localStorage.removeItem('isLoggedin');
        this.showConfirmDelete();
    }

       showConfirmDelete(){
                  var token = this.localstorage.getStorage("token");

let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Admin Account Information', 
                message:'Are you sure you want to logout?',
              data: [],
             showcancel :true})
                .subscribe((isConfirmed)=>{
                  if(isConfirmed){
                    this.loaderService.displayLoader(true);
                    this.shareService.callApiWithToken("admin/adminLogout",null,token).subscribe((result) => {
                        console.log(result.data.status);
                        if(result.data.status){
                            this.localstorage.removeStorage('token');
                            this.loaderService.displayLoader(false);
                            this.router.navigate(['admin/login']);
                        }else{
                            this.localstorage.removeStorage('token');
                            this.loaderService.displayLoader(false);
                            this.router.navigate(['admin/login']);
                        } 
                    });
                  }   
                });

        }

   changeCss(){

       var x= document.getElementById('id3');
       x.classList.toggle("submenuActiveAdmin"); 

    }


    // changeLang(language: string) {
    //     this.translate.use(language);
    // }
}



// WEBPACK FOOTER //
// ./src/app/admin/shared/components/header/header.component.ts